export default "__VITE_ASSET__6d09c5a6__"